export const RESET_USER_COURSE = "RESET_USER_COURSE"
export const RESET_USER_COURSE_SUCCESS = "RESET_USER_COURSE_SUCCESS"
export const RESET_USER_COURSE_CLEAN = "RESET_USER_COURSE_CLEAN"
export const RESET_USER_COURSE_ERROR = "RESET_USER_COURSE_ERROR"